import React from "react";

import cx from "classnames";

import styles from "./Tooltip.scss";

/**
 * Props for the QuestionMarkTooltipIcon component.
 */
export interface QuestionMarkTooltipIconProps {
  /**
   * Ref to the tooltip icon button element
   */
  tooltipIconRef: React.RefObject<HTMLButtonElement>;
  /**
   * Whether the tooltip is currently active
   */
  active: boolean;
  /**
   * Function to set the active state
   */
  setActive: (active: boolean) => void;
  /**
   * Handler for mouse enter event
   */
  onMouseEnter: () => void;
  /**
   * Handler for mouse leave event
   */
  onMouseLeave: () => void;
}

/**
 * Question mark icon button that triggers the tooltip display.
 */
export function QuestionMarkTooltipIcon({
  tooltipIconRef,
  active,
  setActive,
  onMouseEnter,
  onMouseLeave,
}: QuestionMarkTooltipIconProps) {
  return (
    <button
      ref={tooltipIconRef}
      data-testid="tooltip-help-icon"
      className={cx({
        [styles["tooltip-icon"]]: true,
        [styles["tooltip-icon-inactive"]]: !active,
        [styles["tooltip-icon-active"]]: active,
      })}
      onFocus={() => setActive(true)}
      onBlur={() => setActive(false)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      type="button"
    >
      ?
    </button>
  );
}
